
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.59 6.215c.246-.246.246-.656 0-.93L8.996.691c-.437-.41-1.121-.109-1.121.465v2.625H4.156c-.383 0-.656.301-.656.656v2.625c0 .383.273.657.656.657h3.719v2.625c0 .601.71.875 1.121.465l4.594-4.594zm-8.34 4.457V9.578a.353.353 0 00-.328-.328H2.625a.864.864 0 01-.875-.875v-5.25c0-.465.383-.875.875-.875h2.297a.332.332 0 00.328-.328V.828A.353.353 0 004.922.5H2.625A2.626 2.626 0 000 3.125v5.25A2.626 2.626 0 002.625 11h2.297a.332.332 0 00.328-.328z","fill":"#E2E1E1"}})])
          )
        }
      }
    